export default __webpack_public_path__ + "static/media/no-results-found.6a3d81e2.png";